const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");

const Reflux = require("reflux");
const ProductsBestSellersStore = require("../../stores/products-best-sellers-store");
const ProductsBestSellersActions = require("../../actions/products-best-sellers-actions");

const DealsChart = require("./ProductsBestSellers/deals-chart")
const QuantityChart = require("./ProductsBestSellers/quantity-chart")
const ValueChart = require("./ProductsBestSellers/value-chart")

const Dropdown = require("app/shared/components/Dropdown/dropdown");

const GROUP_OPTIONS = [
  { id: "product", name: "Produtos mais vendidos" },
  { id: "category", name: "Categorias mais vendidas" }
];

const TYPE_OPTIONS = [
  { id: "total_value", name: "Por valor" },
  { id: "quantity", name: "Por quantidade" },
  { id: "deals", name: "Por negócios" }
];

const ProductsBestSellersWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return ProductsBestSellersStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(ProductsBestSellersStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps, prevState) {
    if (
      prevProps != this.props
        || prevState.type != this.state.type
        || prevState.group != this.state.group
    ) {
      this.refresh();
    }
  },

  refresh: function() {
    ProductsBestSellersActions.fetchData(
      this.props.period,
      this.props.users,
      this.props.funnel,
      this.state.type,
      this.state.group
    );
  },

  getPercentageValue: function (tooltipItem, data, total) {
    if (total === 0) return 0;

    return parseFloat(
      data[tooltipItem.index].value
        * 100
        / total
    ).toFixed(2);
  },

  getDetailsUrl: function(id) {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("sn", 2);
    searchParams.append("dci", formattedStartDate);
    searchParams.append("dcf", formattedEndDate);
    searchParams.append("pro", id);
    searchParams.append("qpp", 25);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  handleChangeType: function(value) {
    ProductsBestSellersActions.changeType(value);
  },

  handleChangeGroup: function(value) {
    ProductsBestSellersActions.changeGroup(value);
  },

  getItemFromElement: function(element) {
    return element && this.state.data.products[element._index];
  },

  isInteractiveItem: function(item) {
    return item && !item.rest;
  },

  getChart: function() {
    const onHover = (event, [element]) => {
      if (this.state.group === "category") {
        return;
      }
      let item = this.getItemFromElement(element);
      if (this.isInteractiveItem(item)) {
        event.target.style.setProperty("cursor", "pointer");
      } else {
        event.target.style.removeProperty("cursor");
      }
    }
    const onClick = (_, [element]) => {
      if (this.state.group === "category") {
        return;
      }

      if (element) {
        let item = this.getItemFromElement(element);
        if (this.isInteractiveItem(item)) {
          window.open(this.getDetailsUrl(item.id), "_blank");
        }
      }
    }

    if (this.state.data.products.length <= 0){
      return this.emptyList();
    }

    switch (this.state.type) {
      case "total_value":
        return (
          <ValueChart
            getPercentageValue={this.getPercentageValue}
            data={this.state.data.products}
            total={this.getTotalValue()}
            onHover={onHover}
            onClick={onClick}
          />
        )

      case "quantity":
        return (
          <QuantityChart
            getPercentageValue={this.getPercentageValue}
            data={this.state.data.products}
            total={this.getTotalValue()}
            onHover={onHover}
            onClick={onClick}
          />
        )

      default:
        return (
          <DealsChart
            data={this.state.data.products}
            total={this.getTotalValue()}
            onHover={onHover}
            onClick={onClick}
          />
        )
    }
  },

  getTotalValue: function() {
    return this.state.data.products
      .map(p => p.value)
      .reduce((prev, curr) => prev + curr, 0);
  },

  emptyList: function() {
    return (
      <div className='p-a p-20 w-100pct h-100pct d-f flex-column jc-center align-center bg-white zi-10'>
        <div className="mb-30 lh-24 c-normalGrey ta-c">
          Não há informações de quantidade e valor de produtos para o período selecionado. <a target="_blank" href="https://ajuda.agendor.com.br/pt-BR/articles/6369421-como-funcionam-os-campos-de-quantidade-e-valor-por-produto-servico">Saiba mais</a>
        </div>
      </div>
    );
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <Dropdown className="mt-0 pl-0"
            value={this.state.group}
            handleCustomChange={this.handleChangeGroup}
            options={GROUP_OPTIONS}
          />
        }
        className="grid-item-col-2"
        control={
          <div className="ml-a text-muted fs-14">
            <Dropdown className="mt-0"
              value={this.state.type}
              handleCustomChange={this.handleChangeType}
              options={TYPE_OPTIONS}
            />
          </div>
        }
        footer={
          <span className="text-muted">
            Clique numa barra para ver a lista de negócios
          </span>
        }
      >
      {
        this.getChart()
      }
      </CardWithLoader>
    );
  }
});

module.exports = ProductsBestSellersWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/products-best-sellers-widget.jsx